export const BidCategory = {
  ENERGY: "energy",
  FCAS: "fcas"
};
